import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b957a0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = { class: "card_text_and_image_wrapper" }

import TextBlock from "../blocks/TextBlock.vue";
import ContentWrapper from "../generics/ContentWrapper.vue";
import PageTitle from "../blocks/PageTitle.vue";
import CustomCard from "../generics/CustomCard.vue";
import CustomPic from "../generics/CustomPic.vue";
import TextImgContentBlock from "../blocks/TextImgContentBlock.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ArticlesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(ContentWrapper, { backgroundImageClass: "background-trainbridge" }, {
    default: _withCtx(() => [
      _createVNode(PageTitle, { text: "Artiklar" }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "artiklar/cykla-i-europa"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/cykla-i-europa.jpg",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Cykla i Europa",
                  content: "Hur tar man cykeln på tåget? Hur mycket kostar det? Hur gör man\n              det? Här är svaren du letar efter. Ta med cykeln på tågluff i Europa!"
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "artiklar/funktionsvariation"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/map_detail_view.jpg",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Tågluffa med funktionsvariation",
                  content: "Vi går igenom vilka rättigheter man har och vilken hjälp man kan få som funktionsnedsatt på en tågluff i Europa. Läs vår artikel för att resan ska gå så smidigt som möjligt."
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})